import { render, staticRenderFns } from "./AModalScope.vue?vue&type=template&id=7ec60139&"
import script from "./AModalScope.vue?vue&type=script&lang=js&"
export * from "./AModalScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports